import React, { useState } from "react";
import Sidebar from "./Sidebar";
import APIs from "../../APIs";
import { toast } from "react-toastify";

const ChangePassword = () => {
  const [passwords, setPasswords] = useState({
    currentPassword: "",
    newPassword: "",
    confirmPassword: "",
  });

  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState({
    currentPassword: false,
    newPassword: false,
    confirmPassword: false,
  });

  const validatePasswords = () => {
    const newErrors = {};
    if (!passwords.currentPassword)
      newErrors.currentPassword = "Current password is required";
    if (!passwords.newPassword)
      newErrors.newPassword = "New password is required";
    else if (passwords.newPassword.length < 6)
      newErrors.newPassword = "Password must be at least 6 characters";

    if (!passwords.confirmPassword)
      newErrors.confirmPassword = "Confirm password is required";
    else if (passwords.newPassword !== passwords.confirmPassword)
      newErrors.confirmPassword = "Passwords do not match";

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!validatePasswords()) return;

    const storedUserData = JSON.parse(sessionStorage.getItem("userData"));
    const user_id = storedUserData?.user_id;
    if (!user_id) {
      toast.error("User not found. Please login again.");
      return;
    }

    setLoading(true);
    try {
        const response = await APIs.post("user/updatePassword", {
            user_id: user_id,
            old_password: passwords.currentPassword,
            // current_password: passwords.currentPassword,
           new_password: passwords.newPassword,
        });
        console.log("====",response);

      if (response.data.status === "success") {
        toast.success("Password updated successfully!");
        setPasswords({
          currentPassword: "",
          newPassword: "",
          confirmPassword: "",
        });
      } else {
        toast.error(response.data.message || "Failed to update password");
      }
    } catch (error) {
      toast.error(error.response?.data?.message || "Failed to update password");
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setPasswords({ ...passwords, [name]: value });
  };

  return (
    <div className="page-content">
      <section className="step-section-md">
        <div className="container">
          <div className="row">
            <div className="col-lg-3">
              <Sidebar />
            </div>
            <div className="col-lg-9">
              <div className="card mt-30">
                <div className="card-header bg-white">
                  <h5 className="card-title">Change Password</h5>
                </div>
                <div className="card-body">
                  <form onSubmit={handleChangePassword}>
                    <div className="row">
                      <div className="col-md-12 mb-3 position-relative">
                        <label className="form-label">Current Password</label>
                        <input
                          type={
                            showPassword.currentPassword ? "text" : "password"
                          }
                          name="currentPassword"
                          className="form-control"
                          value={passwords.currentPassword}
                          onChange={handleInputChange}
                        />
                        <span
                          className="position-absolute"
                          style={{
                            cursor: "pointer",
                            top: "60%",
                            right: "35px",
                            transform: "translateY(-50%)",
                          }}
                          onClick={() =>
                            setShowPassword({
                              ...showPassword,
                              currentPassword: !showPassword.currentPassword,
                            })
                          }
                        >
                          <i
                            className={`${
                              showPassword.currentPassword
                                ? "bi bi-eye-slash"
                                : "bi bi-eye"
                            }`}
                          ></i>
                        </span>
                        {errors.currentPassword && (
                          <small className="text-danger">
                            {errors.currentPassword}
                          </small>
                        )}
                      </div>

                      <div className="col-md-12 mb-3 position-relative">
                        <label className="form-label">New Password</label>
                        <input
                          type={showPassword.newPassword ? "text" : "password"}
                          name="newPassword"
                          className="form-control"
                          value={passwords.newPassword}
                          onChange={handleInputChange}
                        />
                        <span
                          className="position-absolute"
                          style={{
                            cursor: "pointer",
                            top: "60%",
                            right: "35px",
                            transform: "translateY(-50%)",
                          }}
                          onClick={() =>
                            setShowPassword({
                              ...showPassword,
                              newPassword: !showPassword.newPassword,
                            })
                          }
                        >
                          <i
                            className={`${
                              showPassword.newPassword
                                ? "bi bi-eye-slash"
                                : "bi bi-eye"
                            }`}
                          ></i>
                        </span>
                        {errors.newPassword && (
                          <small className="text-danger">
                            {errors.newPassword}
                          </small>
                        )}
                      </div>

                      <div className="col-md-12 mb-3 position-relative">
                        <label className="form-label">
                          Confirm New Password
                        </label>
                        <input
                          type={
                            showPassword.confirmPassword ? "text" : "password"
                          }
                          name="confirmPassword"
                          className="form-control"
                          value={passwords.confirmPassword}
                          onChange={handleInputChange}
                        />
                        <span
                          className="position-absolute"
                          style={{
                            cursor: "pointer",
                            top: "60%",
                            right: "35px",
                            transform: "translateY(-50%)",
                          }}
                          onClick={() =>
                            setShowPassword({
                              ...showPassword,
                              confirmPassword:
                                !showPassword.confirmPassword,
                            })
                          }
                        >
                          <i
                            className={`${
                              showPassword.confirmPassword
                                ? "bi bi-eye-slash"
                                : "bi bi-eye"
                            }`}
                          ></i>
                        </span>
                        {errors.confirmPassword && (
                          <small className="text-danger">
                            {errors.confirmPassword}
                          </small>
                        )}
                      </div>
                    </div>

                    <div className="card-footer bg-white">
                      <button
                        type="submit"
                        className="btn btn-success"
                        disabled={loading}
                      >
                        {loading ? "Updating..." : "Update Password"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ChangePassword;
